<template>
  <div class="about">
    <div class="introduction">
      <h1>公司简介:</h1>
      <p>
        乐式物联, 是一家专注于无线通讯控制领域的物联网技术研发及应用的国家级高新技术企业。乐式成立于2013年, 成立之初, 以「无线IoT连接打造室内物联系统」为使命,
        致力于为室内智能设备产业链提供基于新一代物联网技术的AIoT产品+SaaS服务, 帮助产业链三端客户, 即设备制造企业、品牌企业、智能集成企业, 以最优成本、最高效率实现AIoT产品化。
      </p>
      <p>
        乐式基于BLE Mesh蓝牙协议的多平台物联系统, 为客户构建完整的一站式智能交付平台, 业务主要涵盖了智能模块接入平台、智能硬件产品定制开发、SaaS服务、云平台对接; 乐式合作平台:
        小米IoT、小度智能、涂鸦、腾讯连连等。
      </p>
      <p>
        截止目前, 乐式已专注在中山照明产业带深耕智能照明领域服务10年, 累计服务包括雷士照明、松下照明、柏曼照明、广东霍明、欧曼股份、西顿照明等品牌客户, 同时还在电工、窗帘电机、传感器等领域,
        服务于友邦吊顶、奥普股份、杜亚电机、联恒智控、瑞克斯电机、天朗、拉斐等企业。
      </p>
      <p>乐式特色优势系统、产品:</p>
      <p>
        <span>1、接入小米IoT照明、电工、电机、传感器等产品, 累计出货达一千万个模块; </span>
        <span>2、小度智慧酒店直连Mesh方案+本地互控系统, 累计出货约一百万个模块; </span>
        <span>3、2020年完成基于SIG Mesh打造了蓝牙模块+网关模块的硬件、嵌入式软件+APP定制系统。</span>
      </p>
    </div>
    <img :src="bk" />
  </div>
</template>

<script>
import { _isMobile, _isWeChat } from '@/utils/config';
import { getAppLists } from '@/utils/service';

export default {
  metaInfo: {
    title: 'Lemesh',
    meta: [
      {
        name: 'keywords',
        content: '小米IoT,米家智能,天猫精灵,全屋智能,智慧酒店,智慧公寓,智能商业照明,百度智能,华为智能,华为hilink,无主灯智能,无线智能,蓝牙mesh智能,去中心化无线智能,物联模组,WiFi',
      },
      {
        name: 'description',
        content: '乐式科技, 专业家居商业照明解决方案, 天猫小米IoT平台服务商, 国内行业智慧物联解决方案IoT平台',
      },
    ],
  },
  name: 'saas',
  components: {},
  data() {
    return {
      isMobile: _isMobile(),
      isWeChat: _isWeChat(),
      lists: [],
      show: false,
      bodyWidth: 0,
      bk: require('./resources/bk.jpeg'),
    };
  },
  async mounted() {
    this.bodyWidth = document.body.clientWidth;

    let response = await getAppLists();
    this.lists = response;
  },
  methods: {
    onClick(url) {
      if (this.isWeChat) {
        this.show = true;
      } else {
        location.href = url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
